import { render, staticRenderFns } from "./invalideLink.vue?vue&type=template&id=b787fc2e&scoped=true"
import script from "./invalideLink.vue?vue&type=script&lang=js"
export * from "./invalideLink.vue?vue&type=script&lang=js"
import style0 from "./invalideLink.vue?vue&type=style&index=0&id=b787fc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b787fc2e",
  null
  
)

export default component.exports